import React from 'react';
import { AsyncInlineResolutionEdit } from '@atlassian/jira-issue-field-resolution/src/async.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { FieldLoader } from '../../common/ui/field-loader/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { closeMenuOnScroll } from '../../common/utils/select/index.tsx';
import { validateResolutionField } from '../../common/utils/validators/index.tsx';
import type { Props, ResolutionFieldConfig, FieldValue } from './types.tsx';
import { mapAllowedValuesToSelectOptions, transformDefaultResolutionValue } from './utils.tsx';

const ResolutionField = (props: Props) => {
	const {
		allowedValues,
		fieldId,
		width,
		error,
		fieldProps: { value, onChange, ...fieldProps },
		autoFocus = false,
		onCloseMenuOnScroll = closeMenuOnScroll,
		isDropdownMenuFixedAndLayered = false,
	} = props;
	return (
		<FieldContainer width={width}>
			<Placeholder name="inline-resolution-edit" fallback={<FieldLoader />}>
				<AsyncInlineResolutionEdit
					{...fieldProps}
					options={mapAllowedValuesToSelectOptions(allowedValues)}
					value={value}
					// @ts-expect-error - TS2322 - Type '(value: ResolutionOption) => void' is not assignable to type '(option: ResolutionOption) => Promise<undefined> | undefined'.
					onChange={onChange}
					isInvalid={Boolean(error)}
					autoFocus={autoFocus}
					classNamePrefix={`resolution-field-${fieldId}`}
					onCloseMenuOnScroll={onCloseMenuOnScroll}
					isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
				/>
			</Placeholder>
		</FieldContainer>
	);
};

export default withFormField({
	transformDefaultValue: transformDefaultResolutionValue,
	validator: validateResolutionField,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ResolutionFieldConfig, ResolutionOption>, any>'.
})<ResolutionFieldConfig, FieldValue>(ResolutionField);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateResolutionField } from './utils';
